module.exports = __webpack_public_path__ + "static/media/search.8e35d11f.svg";